__turbopack_context__.v({
  "expanded": "fgzM2q_expanded",
  "flyout": "fgzM2q_flyout",
  "flyout-link-icon": "fgzM2q_flyout-link-icon",
  "flyout-link-text": "fgzM2q_flyout-link-text",
  "nav": "fgzM2q_nav",
  "overlay": "fgzM2q_overlay",
  "placeholder": "fgzM2q_placeholder",
  "toggle": "fgzM2q_toggle",
  "visible": "fgzM2q_visible",
});
